/**
 * OPEN IN MESSAGES (ITP-E-268-01, Plan ITP-P-58): the Chat panel's conversation menus open a chat on the Messages page,
 * in a tab of its own. One helper for both menus, the thread ⋯ and the row ⋯: who sees it, where it goes, how it opens.
 */

/** The licence on the Messages page's menu item (`21. Orbitax Meet.json`, package WWOMQ): the item shows to its holders. */
export const MESSAGES_FEATURE = 'OM-Messages';

/** The item's words and glyph in both menus; the glyph is Open in Meet's on the call card. */
export const OPEN_IN_MESSAGES = {icon: 'fa-regular fa-arrow-up-right-from-square', label: 'Open in Messages'};

/** Whether the security store's `hasFeature` says the user holds the Messages page. */
export function holdsMessages(hasFeature: ((id: string) => unknown) | null | undefined): boolean {
  return typeof hasFeature === 'function' && !!hasFeature(MESSAGES_FEATURE);
}

/** The Messages page on one chat: the route `messages/:conversationId` under /meet, with base href `/`. */
export function messagesPageUrl(conversationId: string): string {
  return '/meet/messages/' + encodeURIComponent(conversationId);
}

/**
 * Opens the chat on the Messages page in a new tab; this tab stays as it was. With `noopener` the new tab starts with its
 * own sessionStorage, so it takes its own tab id (`core/services/tab-id.service.ts`) and "one tab owns the call"
 * (ITP-E-175) holds. The session is a cookie, so the new tab is signed in to the same company.
 */
export function openInMessages(conversationId: string): void {
  window.open(messagesPageUrl(conversationId), '_blank', 'noopener');
}
